export const safeString = (value, fallback = '') => {
  try {
    if (value === null || value === undefined) return fallback;
    if (typeof value === 'string') return value.trim();
    if (typeof value === 'number') return value.toString();
    return fallback;
  } catch (err) {
    console.error('Error in safeString:', err);
    return fallback;
  }
};

export const safeUrl = (address) => {
  try {
    const cleanAddress = safeString(address, 'Unknown Address');
    if (!cleanAddress || cleanAddress === 'Unknown Address') return null;
    return cleanAddress.toLowerCase().replace(/\s+/g, '-');
  } catch (err) {
    console.error('Error creating URL:', err);
    return null;
  }
};

export const formatCurrency = (value) => {
  if (!value) return 'N/A';
  return new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};